import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

/**
 * PHCNY-specific overrides layered on top of the Optum baseline theme.
 *
 * Keep this config as deltas only; any token or asset omitted here
 * inherits from the default Optum theme.
 */
export const PHCNY_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/phcny/logo.png",
        alt: "Psychiatry Services of New York Logo",
        style: {
          width: "200px",
          height: "100%",
          padding: "10px 0",
          isMobile: { width: "150px" },
        },
      },
    },
    icons: {},
  },
  providerGroupId: 25,
  state: "NY",
  departmentIds: [142, 143, 158, 171, 235],
};
